export function ErrorPage() {
  const params = new URLSearchParams(window.location.search);
  const reason = params.get('reason');

  return (
    <section className="system-page" aria-labelledby="error-page-title">
      <div className="system-page__panel" role="alert">
        <h1 id="error-page-title">Something went wrong</h1>
        <p>
          The shell could not complete the requested navigation. Try refreshing the page or return
          to the home page.
        </p>
        {reason ? <p className="system-page__muted">Reason: {reason}</p> : null}
        <a className="system-page__link" href="/">
          Return home
        </a>
      </div>
    </section>
  );
}
